let slider = document.querySelector("#slider")
let page = document.querySelector("body")

// open nav event listener
document.querySelector(".openNav").addEventListener("click", function () {

    if (slider.classList.contains('active')) {
        slider.classList.remove("active");
        page.classList.remove("noScroll");
    } else {
        slider.classList.add("active");
        page.classList.add("noScroll");
    }
    ;

});